import { authAPI } from 'api/authAPI';
import {
  INIT_ORG_ACCESS,
  INIT_PAGE_ACCESS,
  INIT_PERSON_ACCESS,
  MODULE_TYPES,
} from 'constants/access.constants';
import * as React from 'react';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';

const removeOverlapPermission = (data) => {
  let result = JSON.parse(JSON.stringify(INIT_PAGE_ACCESS));

  data.forEach((group) => {
    const { module, canview, canupdate, canadmin } = group;
    const { label, type } = module;
    if (type && label) {
      // @ts-ignore
      const convertedType = MODULE_TYPES[type];
      // get the highest permission (true is hightest) if data are overlap
      if (!result[convertedType]) result[convertedType] = {};
      if (result?.[convertedType]?.[label]?.key === label) {
        if (canview) result[convertedType][label].canView = canview;
        if (canupdate) result[convertedType][label].canUpdate = canupdate;
        if (canadmin) result[convertedType][label].canAdmin = canadmin;
      } else {
        result[convertedType][label] = {
          canAdmin: canadmin,
          canView: canview,
          canUpdate: canupdate,
          key: label,
        };
      }
    }
    // });
  });

  return result;
};

export const UserPermissionCtx = React.createContext({
  org: INIT_ORG_ACCESS,
  person: INIT_PERSON_ACCESS,
  isLoading: false,
  groups: [],
});

export const transformPermission = (result) => {
  let convertedPermissions = {};
  if (result?.data?.accesscontrol) {
    convertedPermissions = removeOverlapPermission(result?.data?.accesscontrol);
  }

  const groups = result?.data?.ldapgroup || [];

  return { ...convertedPermissions, groups };
};

export const UserPermissionProvider = ({ children }) => {
  const { loading, authenticated } = useSelector((state) => state.users);
  const { data, isFetching } = useQuery('userAccess', authAPI.getUserAccess, {
    select: transformPermission,
    enabled: !loading && authenticated,
    onError: (e) => {
      console.log('error get permissions:', e);
    },
  });

  // console.groupCollapsed('UserPermissionProvider');
  // console.log(data, ', :data');
  // console.log(isFetching, ', :isFetching');
  // console.groupEnd();

  const { person = {}, org = {}, groups = [] } = data || {};

  return <UserPermissionCtx.Provider value={{ org, person, isLoading: isFetching, groups }}>{children}</UserPermissionCtx.Provider>;
};

export const useUserPermission = () => {
  const value = React.useContext(UserPermissionCtx);

  return value;
};
